module.exports = __webpack_public_path__ + "img/5.773953e1.jpg";